export class Address {

  public city: string;
  public country: string;
  public district: string;
  public latitude: number;
  public longitude: number;
  public number: string;
  public state: string;
  public street: string;
  public zipcode: string;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/address.ts